export default __webpack_public_path__ + "static/jack and vicki somppi-fa7b6849fa954fd7a31cba95d5c378f8.webp";